import React,{useEffect} from 'react'
import Hero from '../Components/Hero/Hero'
import About from '../Components/About/About'
import Contact from '../Components/Contact/Contact'
import Projects from '../Components/Projects/Projects'
import Skills from '../Components/Skills/Skills'
import ProjectDetails from '../Components/ProjectDetails/ProjectDetails'

const Home = () => {

  useEffect(()=>{window.scrollTo(0,0);},[]);

  return (
    <div>
      <Hero />
      <Projects />
      <About />
      <Skills />
      <ProjectDetails />
      <Contact />
    </div>
  )
}

export default Home
